import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Payroll = Loadable(lazy(() => import('./Payroll/Payroll')));

const payrollRoutes = [
    { path: '/employee/payroll', element: <Payroll />, auth: authRoles.guest },
];

export default payrollRoutes;
